import React, { useEffect, useState } from "react";

const MessageA15 = (props) => {
  const { inputValue } = props;

  // const checkButton = () => {
  //   let userText = props?.item?.text || "Submit"
  //   const buttonTextOptions = ["Yes", "No", "Submit", "Confirm" ,"Send OTP"];
  
  //   // Check if any of the options are included in userText
  //   if (buttonTextOptions.some(option => userText.includes(option))) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
  const checkButton = () => {
    let userText = props?.item?.text;
    const buttonTextOptions = ["Yes", "No", "Submit", "Confirm", "Send OTP", "Got it"];
  
    return buttonTextOptions.includes(userText);
  };


  return (
    <div style={{ marginTop: "10px" }}>
      <button
        ref={inputValue}
        disabled={props.disabled}
        className="submit-btn"
      >
        <span
          className={
            !props.disable
              ? "chat-label action-tab "
              : "chat-labelnohover action-tab"
          }
          style={{ color: props.disable && "grey" ,borderRadius: checkButton() ? "4px" : '44px',  }}
          id="main-tab1"
          onClick={() => {
            const data = JSON.parse(localStorage.getItem("inputValue"));
            // console.log("Input--->", data);
            if (!props.disable) {
              props.handleClick(props.item.code, data);
              props.setTextOnClick(props.item.text);
            }
          }}
        >
          {props.item.text || "Submit"}
        </span>
      </button>
    </div>
  );
};

export default MessageA15;
